import type { FC, ReactNode } from "react";
import { Row } from "@/components/common/row.ts";
import { IconX } from "@/icons/IconX.tsx";
import {
  ClosingReason,
  ModalBackground,
  ModalClose,
  ModalContent,
  ModalHeader,
} from "@/components/modal/shared.ts";

interface ModalProps {
  children?: ReactNode;
  title?: string;
  onClick?: (reason: ClosingReason) => void;
}

export const ModalSimple: FC<ModalProps> = ({ children, title, onClick }) => {
  const click = (reason: ClosingReason) => {
    if (onClick) {
      onClick(reason);
    }
  };

  return (
    <ModalBackground>
      <ModalContent>
        <Row data-width="full" data-justify="between">
          <ModalHeader>{title}</ModalHeader>
          <ModalClose
            onClick={() => {
              click(ClosingReason.Abort);
            }}
          >
            <IconX />
          </ModalClose>
        </Row>
        {children}
      </ModalContent>
    </ModalBackground>
  );
};
